import { render } from "./App.vue?vue&type=template&id=7ba5bd90&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@/assets/css/styles.css?vue&type=style&index=0&id=7ba5bd90&scoped=true&lang=css&external"
import "@/assets/css/fonts.css?vue&type=style&index=1&id=7ba5bd90&scoped=true&lang=css&external"
import "./App.vue?vue&type=style&index=2&id=7ba5bd90&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba5bd90"],['__file',"src/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ba5bd90"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ba5bd90', __exports__)) {
    api.reload('7ba5bd90', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=7ba5bd90&scoped=true", () => {
    api.rerender('7ba5bd90', render)
  })

}


export default __exports__